<template>
    <editCurator v-if="openEdit" @closeModal="openEdit = false"/>
    <div class="mainStyle3">
        <div class="mainStyle3__left">
            <platformTable />
        </div>
        <div class="mainStyle3__right">
            <div class="mainStyle3__right__top">
                <div class="mainStyle3__right__top__left">
                    <p class="mainStyle3__right__top__left__title"> Личный кабинет</p>
                </div>
                <div class="mainStyle3__right__top__right">
                    <userInfo />
                </div>
            </div>
            <div class="blocks">
                <div class="blocks__top">
                    <div class="info customBackground">
                        <div class="info__top" style="cursor: pointer;">
                            <img :src="userInfo?.image" class="info__top__image" @click="openEdit = true"/>
                            <div class="info__top__right" @click="openEdit = true">
                                <div class="info__top__right__edit">
                                    <p class="info__top__right__name">{{userInfo?.surname ?? ''}} {{userInfo?.name ? userInfo?.name : 'ФИО'}}</p>
                                    <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.5 17.125V21.5H4.875L17.7783 8.59666L13.4033 4.22166L0.5 17.125ZM21.1617 5.21333C21.2698 5.1054 21.3556 4.97719 21.4142 4.83606C21.4727 4.69492 21.5028 4.54363 21.5028 4.39083C21.5028 4.23803 21.4727 4.08674 21.4142 3.9456C21.3556 3.80447 21.2698 3.67626 21.1617 3.56833L18.4317 0.838331C18.3237 0.730177 18.1955 0.644372 18.0544 0.585827C17.9133 0.527282 17.762 0.497147 17.6092 0.497147C17.4564 0.497147 17.3051 0.527282 17.1639 0.585827C17.0228 0.644372 16.8946 0.730177 16.7867 0.838331L14.6517 2.97333L19.0267 7.34833L21.1617 5.21333Z" />
                                    </svg>
                                </div>
                                <div class="info__top__right__status">
                                    <img src="@/assets/icons/curatorIcon.svg"/>
                                    <p>{{
                                            userInfo?.role?.name === 'supervisor' ? 'НО10'
                                                : userInfo?.role?.name === 'chief' ? 'НО12'
                                                    : userInfo?.role?.name
                                        }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="line"></div>
                        <div class="info__status" @dblclick="disactive(userInfo.id)" v-if="userInfo?.status == 'Активный'">
                            Статус: <span>Активен</span>
                        </div>
                        <div class="info__status" v-else style="background-color: red;" @dblclick="active(userInfo.id)">
                            Статус: <span>Неактивен</span>
                        </div>
                    </div>
                    <!-- <div class="request customBackground" v-if="$store.state.role == 'chief'">
                            <div class="customTop">
                                <div class="customTop__left">
                                    <img src="@/assets/icons/app.svg"/>
                                    <p>Заявки на обсуждение</p>
                                </div>
                                <div class="customTop__select">
                                    <CustomSelect :mini-select="true"/>
                                </div>
                            </div>
                            <div class="request__bot">
                                <swiper 
                            class="request__bot__swiper"
                                :breakpoints="{
                                    0: {
                                        slidesPerView: 3,
                                        slidesPerGroup: 3
                                    }
                                }"
                                :pagination="{
                                     el: '.swiper-pag',
                                }"
                                :spaceBetween="40"
                                :speed="500"
                                :lazy="true" 
                            > 
                                <swiper-slide v-for="(item) in meetings" class="request__bot__swiper__slide" style="cursor: pointer;"
                                    :key="item" @click="$router.push(`/curator/users/${item?.user?.id}?tab=3`)"> 
                                    <img :src="item?.user?.image_url"/>
                                    <p class="text">ID:{{item?.user?.id}}</p>
                                    <p class="name">{{item?.user?.name}}</p>
                                </swiper-slide>
                            </swiper>
                            </div>
                            <div class="swiper-pag"></div>  
                            </div>
                            
                             <div class="access customBackground">
                                <div class="customTop">
                                    <div class="customTop__left">
                                        <img src="@/assets/icons/access.svg"/>
                                        <p>Доступ к ресурсам</p>
                                    </div>
                                </div>
                                <div class="access__bot">
                                    <div class="access__bot__in" v-for="item in recources" :key="item">
                                        <a :href="item.link"><img :src="item.icon"/></a>
                                    </div>
                                </div>
                            </div> -->
                    <!-- <div class="results customBackground">
                        <div class="customTop">
                            <div class="customTop__left">
                                <img src="@/assets/icons/app.svg"/>
                                <p>Результаты</p>
                            </div>
                            <div class="customTop__select">
                                <CustomSelect :mini-select="true"/>
                            </div>
                        </div>
                            <swiper 
                                class="results__swiper"
                                :slidesPerView="1" 
                                :speed="1000"
                                :pagination="{ 
                                            clickable: true, 
                                            el: '.swiperNav1'}"
                                :lazy="true" 
                            > 
                                <swiper-slide v-for="(item) in results" :key="item" class="results__swiper__slide"> 
                                    <div class="results__swiper__slide__left">
                                        <img src="@/assets/icons/resul.svg"/>
                                    </div>
                                    <div class="results__swiper__slide__right">
                                        <p class="results__swiper__slide__right__top">{{item?.title}}</p>
                                        <p class="results__swiper__slide__right__count">{{ item?.value }}</p>
                                    </div>
                                </swiper-slide> 
                            </swiper>
                            <div class="swiperNav1"></div>
                    </div> -->
                    <!-- <div class="results customBackground">
                        <div class="customTop">
                            <div class="customTop__left">
                                <img src="@/assets/icons/app.svg"/>
                                <p>Статистика</p>
                            </div>
                            <div class="customTop__select">
                                <CustomSelect :mini-select="true" :list="curators"/>
                            </div>
                        </div>
                            <swiper 
                                class="results__swiper"
                                :slidesPerView="1" 
                                :speed="1000"
                                :pagination="{ 
                                            clickable: true, 
                                            el: '.swiperNav2'}"
                                :lazy="true" 
                                :loop="true"
                            > 
                                <swiper-slide v-for="(item) in 4" :key="item" class="results__swiper__slide"> 
                                    <div class="results__swiper__slide__left">
                                        <img src="@/assets/icons/resul.svg"/>
                                    </div>
                                    <div class="results__swiper__slide__right">
                                        <p class="results__swiper__slide__right__top">ТОП-50</p>
                                        <p class="results__swiper__slide__right__count">34</p>
                                    </div>
                                </swiper-slide> 
                            </swiper>
                            <div class="swiperNav2"></div>
                    </div> -->
                    <!-- <div class="new customBackground">
                        <div class="customTop">
                            <div class="customTop__left">
                                <img src="@/assets/icons/app.svg"/>
                                <p>Новых покупок</p>
                            </div>
                            <div class="customTop__select">
                                <CustomSelect :mini-select="true"/>
                            </div>
                        </div>
                        <swiper 
                                class="results__swiper"
                                :slidesPerView="1" 
                                :speed="1000"
                                :pagination="{ 
                                            clickable: true, 
                                            el: '.swiperNav2'
                                }"
                                :lazy="true" 
                                :loop="true"
                            > 
                                <swiper-slide v-for="(item) in 4" :key="item" class="results__swiper__slide"> 
                                    <div class="results__swiper__slide__left">
                                        <img src="@/assets/icons/basketBlack.svg"/>
                                    </div>
                                    <div class="results__swiper__slide__right">
                                        <p class="results__swiper__slide__right__top">Новых гайдов куплено</p>
                                        <p class="results__swiper__slide__right__count">156</p>
                                    </div>
                                </swiper-slide> 
                            </swiper>
                            <div class="swiperNav2"></div>
                    </div> -->
                </div>
                <div class="blocks__bot">
                    <div class="clients customBackground">
                        <div class="customTop">
                            <div class="customTop__left">
                                <img src="@/assets/icons/achieveIcon.svg"/>
                                <p>Клиенты</p>
                            </div>
                            <div class="customTop__select">
                                <CustomSelect 
                                    :mini-select="true" 
                                    :is-filter="true" 
                                    :is-add-file="false" 
                                    :list="listChosen" 
                                    v-model="chosenCurator"
                                    @change="getCuratorStats(chosenCurator)"
                                /> 
                            </div>  
                        </div>
                        <div class="clients__block">
                            <div class="clients__block__in">
                                <p class="name">{{statistic.totalUserCount}}</p>
                                <p class="text">Общее</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.activeUserCount}}</p>
                                <p class="text">Активные</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.deactivateUserCount}}</p>
                                <p class="text">Неактивные</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.problemUserCount}}</p>
                                <p class="text">Проблемные</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.riskCount}}</p>
                                <p class="text">С рисками</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.thisYearAuthCount}}</p>
                                <p class="text">2025 г.</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.nextYearAuthCount}}</p>
                                <p class="text">2026 г.</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.secondTryCount}}</p>
                                <p class="text">Переподача</p>
                            </div>
                            <div class="clients__block__in">
                                <p class="name">{{statistic.expiredContractsCount}}</p>
                                <p class="text">Истек договор</p>
                            </div>
                        </div>
                    </div>
                    <div class="blocks__bot__right">
                        <div class="blocks__bot__right__top">
                            <!-- <div class="request customBackground">
                            <div class="customTop">
                                <div class="customTop__left">
                                    <img src="@/assets/icons/app.svg"/>
                                    <p>Заявки на обсуждение</p>
                                </div>
                                <div class="customTop__select">
                                    <CustomSelect :mini-select="true"/>
                                </div>
                            </div>
                            <div class="request__bot">
                                <swiper
                            class="request__bot__swiper"
                                :breakpoints="{
                                    0: {
                                        slidesPerView: 3,
                                        slidesPerGroup: 3
                                    }
                                }"
                                :pagination="{
                                     el: '.swiper-pag',
                                }"
                                :spaceBetween="40"
                                :speed="500"
                                :lazy="true"
                            >
                                <swiper-slide v-for="(item) in meetings" class="request__bot__swiper__slide"
                                    :key="item" @click="$router.push(`/curator/users/${item?.user?.id}?isFav=true`)">
                                    <img :src="item?.user?.image_url"/>
                                    <p class="text">ID:{{item?.user?.id}}</p>
                                    <p class="name">{{item?.user?.name}}</p>
                                </swiper-slide>
                            </swiper>
                            </div>
                            <div class="swiper-pag"></div>
                            </div>
                             <div class="access customBackground">
                                <div class="customTop">
                                    <div class="customTop__left">
                                        <img src="@/assets/icons/access.svg"/>
                                        <p>Доступ к ресурсам</p>
                                    </div>
                                </div>
                                <div class="access__bot">
                                    <div class="access__bot__in" v-for="item in recources" :key="item">
                                        <a :href="item.link"><img :src="item.icon"/></a>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="progress1 customBackground">
                            <div class="customTop">
                                <div class="customTop__left">
                                    <img src="@/assets/icons/app.svg"/>
                                    <p>Прогресс бар</p>
                                </div>
                                <div class="customTop__select">
                                    <CustomSelect :mini-select="true"/>
                                </div>
                            </div>
                            <div class="progress1__block">
                                <div class="progress1__block__in" v-for="prog in 4" :key="prog">
                                    <p>Этап 1</p>
                                    <div class="progress1__block__in__color"></div>
                                    <p class="progress1__block__in__percent">54</p>
                                </div>
                            </div>
                            </div> -->
                        </div>
                        <!-- <div class="blocks__bot__right__bot">
                            <div class="statistic customBackground">
                            <div class="customTop">
                                <div class="customTop__left">
                                    <img src="@/assets/icons/app.svg"/>
                                    <p>Статистика</p>
                                </div>
                                <div class="customTop__select">
                                    <CustomSelect :mini-select="true"/>
                                </div>
                            </div>
                            <swiper
                                class="results__swiper"
                                :slidesPerView="1"
                                :speed="1000"
                                :pagination="{  clickable: true, el: '.swiperNav3'}"
                                :lazy="true"
                                :loop="true"
                            >
                                <swiper-slide v-for="(item) in 4" :key="item" class="results__swiper__slide">
                                    <div class="results__swiper__slide__left">
                                        <img src="@/assets/icons/resul.svg"/>
                                    </div>
                                    <div class="results__swiper__slide__right">
                                        <p class="results__swiper__slide__right__top">ТОП-30</p>
                                        <p class="results__swiper__slide__right__count">34</p>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiperNav3"></div>
                            </div>
                            <div class="access customBackground">
                                <div class="customTop">
                                    <div class="customTop__left">
                                        <img src="@/assets/icons/access.svg"/>
                                        <p>Доступ к ресурсам</p>
                                    </div>
                                </div>
                                <div class="access__bot">
                                    <div class="access__bot__in" v-for="item in 8" :key="item">
                                        <img src="@/assets/icons/tg.svg" />
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <!-- <div class="blocks__bot__center">
                        <div class="request customBackground">
                            <div class="customTop">
                                <div class="customTop__left">
                                    <img src="@/assets/icons/app.svg"/>
                                    <p>Заявки на обсуждение</p>
                                </div>
                            </div>
                            <div class="request__bot">
                                <swiper
                            class="request__bot__swiper"
                                :breakpoints="{
                                    0: {
                                        slidesPerView: 3,
                                        slidesPerGroup: 3
                                    }
                                }"
                                :pagination="{
                                     el: '.swiper-pag',
                                }"
                                :spaceBetween="40"
                                :speed="500"
                                :lazy="true"
                            >
                                <swiper-slide v-for="(item, index) in 12" class="request__bot__swiper__slide"
                                    :key="item">
                                    <img src="@/assets/icons/appUser.svg"/>
                                    <p class="text">ID:897688</p>
                                    <p class="name">Иван И.</p>
                                </swiper-slide>
                            </swiper>
                            </div>
                            <div class="swiper-pag"></div>
                        </div>
                        <div class="statistic customBackground">
                            <div class="customTop">
                                <div class="customTop__left">
                                    <img src="@/assets/icons/app.svg"/>
                                    <p>Статистика</p>
                                </div>
                                <div class="customTop__select">
                                    <CustomSelect :mini-select="true"/>
                                </div>
                            </div>
                            <swiper
                                class="results__swiper"
                                :slidesPerView="1"
                                :speed="1000"
                                :pagination="{
                                            clickable: true,
                                            el: '.swiperNav3'
                                }"
                                :lazy="true"
                                :loop="true"
                            >
                                <swiper-slide v-for="(item) in 4" :key="item" class="results__swiper__slide">
                                    <div class="results__swiper__slide__left">
                                        <img src="@/assets/icons/resul.svg"/>
                                    </div>
                                    <div class="results__swiper__slide__right">
                                        <p class="results__swiper__slide__right__top">ТОП-30</p>
                                        <p class="results__swiper__slide__right__count">34</p>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiperNav3"></div>
                        </div>
                    </div>
                    <div class="blocks__bot__right">
                        <div class="progress1 customBackground">
                            <div class="customTop">
                                <div class="customTop__left">
                                    <img src="@/assets/icons/app.svg"/>
                                    <p>Прогресс бар</p>
                                </div>
                                <div class="customTop__select">
                                    <CustomSelect :mini-select="true"/>
                                </div>
                            </div>
                            <div class="progress1__block">
                                <div class="progress1__block__in" v-for="prog in 4" :key="prog">
                                    <p>Этап 1</p>
                                    <div class="progress1__block__in__color"></div>
                                    <p class="progress1__block__in__percent">54</p>
                                </div>
                            </div>
                        </div>
                        <div class="access customBackground">
                        <div class="customTop">
                            <div class="customTop__left">
                                <img src="@/assets/icons/access.svg"/>
                                <p>Доступ к ресурсам</p>
                            </div>
                        </div>
                        <div class="access__bot">
                            <div class="access__bot__in" v-for="item in 8" :key="item">
                                <img src="@/assets/icons/tg.svg" />
                            </div>
                        </div>
                    </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import platformTable from "@/components/platformTable.vue";
import userInfo from "@/components/userInfo.vue";
import { Swiper, SwiperSlide, } from "swiper/vue";
import { mapActions, mapGetters } from "vuex";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import { useHead } from "@vueuse/head"
import SwiperCore, { A11y, Autoplay } from "swiper";
import { Navigation, Pagination, EffectCoverflow } from 'swiper';
import "swiper/swiper.min.css";
SwiperCore.use([Navigation, Pagination, A11y, Autoplay, EffectCoverflow])
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import CustomSelect from "@/components/customSelect.vue";
import axios from "axios";
import editCurator from "@/components/newPlatform/editCurator.vue";
export default {
    components: {
        Swiper,
        SwiperSlide,
        platformTable,
        userInfo,
        CustomSelect,
        editCurator
    },
    data() {
        return {
            meetings: false,
            statistic: false,
            recources: false,
            results: false,
            openEdit: false,
            curators: false,
            listChosen: [],
            chosenCurator: null,
        };
    },
    methods: {
        async getMeetings(){
            await axios.get(`/platform/chief/meetings`, {
            headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.meetings = res.data.meetings
            })
            .catch(err => {
            })
        },
        async getStats(){
            await axios.get(`/platform/supervisor/user-statistics`, {
            headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.statistic = res.data.data; 
                if (this.userInfo.role.name == 'supervisor'){
                    this.listChosen = res.data.curators;
                    this.listChosen.unshift({
                        'id':0,
                        'fio': 'Выбрать все',
                    })
                } else {
                    this.listChosen = res.data.experts;
                    this.listChosen.unshift({
                        'id':0,
                        'fio': 'Выбрать все',
                    })
                }
            })
            .catch(err => {
            }) 
        },
        async getCuratorStats(id){
            if(Number(id) === 0){
                this.getStats();
                return;
            }
            const paramKey = this.userInfo?.role?.name === 'supervisor' ? 'curator_id' : 'expert_id';
            await axios.get(`/platform/supervisor/user-statistics`, {
                params: {
                    [paramKey]: id,
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            }).then(res => {
                this.statistic = res.data.data;
            }).catch(err => {
            })
        },
        async getRecources(){
            await axios.get(`/platform/supervisor/resource-links`, {
            headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.recources = res.data.data;
            })
            .catch(err => {
            }) 
        },
        async getResults(){
            await axios.get(`/platform/supervisor/results`, {
            headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.results = res.data.data
                this.results[0].title = 'Офферы ТOP-50'
                this.results[1].title = 'Офферы ТOP-250'
                this.results[2].title = 'Выигранные стипендии'
                this.results[3].title = 'Платно поступившие'
            })
            .catch(err => {
            }) 
        },
        async getCurators(){
            await axios.get(`/platform/supervisor/curators`, {
            headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then(res => {
                this.curators = res.data.data
            })
            .catch(err => {
            }) 
        },
        disactive(id){
            axios.put(`/platform/curator/deactivate-user/${id}`, '', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then((response) => {
            if (response.status === 200) {
                this.userInfo.status == 'Неактивный'
                window.location.reload();
            } else {
                console.log(response.data);
            }
            })
            .catch((response) => { 
                console.log(response.response.data.errors);
            });
        }, 
        active(id){
            axios.put(`/platform/curator/activate-user/${id}`, '', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                }
            })
            .then((response) => {
            if (response.status === 200) {
                this.userInfo.status == 'Активный'
                window.location.reload();
            } else {
                console.log(response.data);
            }
            })
            .catch((response) => { 
                console.log(response.response.data.errors);
            });
        },
    },
    computed:{
        ...mapGetters(["userInfo"])
    },
    async created(){
        this.getMeetings()
        this.getStats()
        this.getRecources(),
        this.getResults()
        this.getCurators()
    }
};
</script>
<style lang="scss" scoped>
.line{
    border-top: 1px solid #0000001A;
    width: 100%;
}
.text{
    color: #0000008A;
}
.name{
    color: black;
    font-weight: 700;
    font-size: min(max(13px, calc(0.8125rem + ((1vw - 7.68px) * 0.434))), 18px);
}
.results, .new, .clients{
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            width: 31%;
            &__bot{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 10px;
                align-items: center;
            }
            &__swiper{
                width: 100%;
                &__slide{
                    width: 100%;
                    padding: 0 min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    &__left{
                        width: 25%;
                        aspect-ratio: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: #F8F8F8;
                        border-radius: 50%;
                    }
                    &__right{
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        width: 70%;
                        &__count{
                            font-weight: 700;
                            font-size: 64px;
                        }
                    }
                }
            }
 }
 .clients{
    width: 31%;
    &__block{
        display: flex;
        flex-wrap: wrap;
        gap: 3.5%;
        width: 100%;
        row-gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        padding: 0 min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px)80px;
        &__in{
            width: 31%;
            padding: 10px;
            text-align: center;
            gap: 5px;
            aspect-ratio: 1;
            box-shadow: 0px 0px 4px 4px #0000000D inset;
            background-color: #F8F8F8;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        }
    }
}     
.blocks{
    display: flex;
    flex-direction: column;
    gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    &__top{
        display: flex;
        flex-wrap: wrap;
        gap: 3.5%;
        row-gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        align-items: stretch;
        .info{
            position: relative;
            width: 31%;
            background-color: white;
            padding: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
            border-radius: 10px;
            display: flex;
            box-shadow: 0px 4px 3px 1px #0000000D;
            flex-direction: column;
            gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            &__top{
            display: flex;
            gap: 10px;
            align-items: center;
            &__image{
                width: 15%;
                aspect-ratio: 1;
                border-radius: 50%;
                object-fit: cover;
            }
            &__right{
                display: flex;
                width: 85%;
                flex-direction: column;
                gap: 10px;
                img{
                    width: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                }
                &__name{
                    display: block;
                    float: left;
                    width: 85%;
                    color: #11415D;
                    font-weight: 700;
                    font-size:18px;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                }
                &__edit{
                    display: block;
                    width: 100%;
                }
                &__edit svg{
                    position: absolute;
                    display: block;
                    top: 25px;
                    right: 25px;
                }
                &__status{
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    color: #FD2D2A;
                    font-weight: 600;
                }
            }
        }
        &__status{
            display: flex;
            justify-content: center;
            width: fit-content;
            padding: 7px 10px;
            background-color: #14D448;
            border-radius: 10px;
            color: white;
            font-size: 14px;
            cursor: pointer;
            span{
                font-weight: 600;
        
            }
        }
        }
    }
    .request,.access{
                    width: 31%;
                    display: flex;
                    flex-direction: column;
                    gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
                }
    .request{
                    &__bot{
                        width: 100%;
                        &__swiper{
                            width: 100%;
                            padding: 0 min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
                            &__slide{
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                gap: 5px;
                                img{
                                    width: 100%;
                                    aspect-ratio: 1;
                                }
                            }
                        }
                    }
                }
                .access{
                    &__bot{
                        padding: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
                        display: flex;
                        flex-wrap: wrap;
                        gap: 4%;
                        row-gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                        &__in{
                            width: 22%;
                            cursor: pointer;
                            img{
                                width: 100%;
                                object-fit: cover;
                            }
                        }
                    }
                }
    &__bot{
        display: flex;
        flex-wrap: wrap;
        gap: 3.5%;
        row-gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);  
        align-items: stretch;
        &__right{
            width: 65.5%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            &__top, &__bot{
                display: flex;
                justify-content: space-between;
                width: 100%;
                align-items: stretch;
                .progress1{
                    &__block{
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        padding: 0 min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px)10px;
                        &__in{
                            display: flex;
                            flex-direction: column;
                            gap: 5px;
                            position: relative;
                            color: #0000008A;
                            &__color{
                                width: 54%;
                                background-color: #FD2D2A;
                                border-radius: 10px;
                                height: 10px;
                            }
                            &__percent{
                                position: absolute;
                                top: 0%;
                                left: 54%;
                                color: black;
                                transform: translate(-50%);
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>